declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    DATA: any;
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type CustomCallbackType = (...args: any[]) => void | string;

export type ConsentsType = {
  changeDate: string;
  domain: string;
  name: string;
  parsedValue: string;
  value: string;
};

export function isIdsAvailableType(x: unknown): x is IdsAvailableType {
  if (typeof x !== 'object') return false;
  if (x === null) return false;

  if (!('category' in x && typeof x.category === 'string')) return false;
  if (!('domain' in x && typeof x.domain === 'string')) return false;
  if (!('ttl' in x && typeof x.ttl === 'string')) return false;
  if ('mtid' in x && x.mtid && typeof x.mtid !== 'string') return false;
  if ('atid' in x && x.atid && typeof x.atid !== 'string') return false;
  if ('attrid' in x && x.attrid && typeof x.attrid !== 'string') return false;

  return true;
}

export type IdsAvailableType = {
  mtid?: string;
  atid?: string;
  attrid?: string;
  category: string;
  domain: string;
  ttl: string;
} & {
  [id: string]: string;
};

export type IdGraphType = {
  domain: string;
  id?: number;
  mtid?: string;
  atid?: string;
  attrid?: string;
  category: 'mobile' | 'fixed';
  ttl?: string;
};

export type ConnectIdType = {
  consents?: Array<ConsentsType>;
  createdDate?: string;
  domain: string;
  idGraph: Array<IdGraphType>;
  value: string;
  ttl: string;
  id?: number;
  refresh?: boolean;
};

export type IdConnectConfigType = {
  domain: string | null;
  path: string | null;
  protocol: string | null;
  callbackSuccess: CustomCallbackType | null;
  umdid: string | null;
  originalUmdidCookie: string | null;
  dataUmdidCookie: string | null;
  token: string | null;
  net: string | null;
  dataCallCounter: number;
  cryptip?: string;
  version: string;
  connectId?: ConnectIdType | null;
  mnoSelectorDomain?: string;
  dataOriginalUmdidCookie?: object;
  transactionId?: string;
  useCase?: string;
};

export type IdsObjectType = {
  source: {
    connectId: object;
    domain: string;
    umdid: string | null;
    dataOriginalUmdidCookie?: object;
    originalUmdidCookie: string | null;
  };
  target: {
    connectId: object | null;
    domain: string | null;
    umdid: string | null;
    umdidCookie: string | null;
  };
};

export type IdConnectDataType = {
  connectId?: ConnectIdType;
  ids: IdsObjectType;
  connectStatus?: string;
};

export type ConnectMessageType = {
  body: {
    ids: IdsObjectType;
    data?: ConnectIdType;
    umdidCookie: string;
    value: string;
    domain: string;
    token: string;
    net: string;
    originalUmdidCookie: string;
    useCase?: string;
    url: string;
    status: {
      StatusC1: string;
      StatusC2: string;
      CookieReused: boolean;
      Reason?: 'blacklisted';
    };
  };
  msgType: string;
  status: string;
  isTroubleShooting: boolean;
  SetCookieDomain?: string;
};

export type IdConnectConfiguration = {
  IDCONNECT_API_HOST: string;
  IDCONNECT_DATA_STORAGE: string;
  IDCONNECT_DOMAIN_STORAGE_TRANSLATION: Record<string, string>;
  IDCONNECT_STORAGE_TYPE: string;
  IDCONNECT_TYPE: string;
  IDCONNECT_ALLOWED_USE_CASES: Array<string>;
  IDCONNECT_ALLOW_TOKEN_DATA_CALL: boolean;
  IDCONNECT_ALLOW_TOKEN_DATA_CALL_COUNTER: number | null;
};

export type CallsConfiguration = {
  intervalId?: null;
  conditions?: {
    timeConditions?: {
      oncePerSession?: boolean;
      oncePerTimeInterval: number | null;
    };
    oncePerPage?: boolean;
    urls?: null;
  };
  callsToMake?: {
    idConnect: boolean;
  };
  /* oncePerPage overwritten calls */
  callsPerPage?: {
    idConnect: boolean;
  };
};

export type UID = {
  id: string;
  atype: number;
  ext: {
    utiq: {
      category: 'mobile' | 'fixed' | 'netid';
    };
  };
};

export type UtiqOpenRtbEids = {
  source: string;
  uids: UID[];
};
